import FollowerDetails from './FollowerDetails';
import Import from './import';

const followers = {
  title: 'Følgere',
  fields: {
    name: 'Navn',
    subscribed: 'Tilmeldt',
    followed: 'Følger',
    phone: 'Telefon',
    recent_order: 'Seneste ordre',
    total_orders: 'Ordrer i alt',
    birthday: 'Fødselsdag',
    google_review: 'Google-anmeldelse',
    marketing_subscription_source: 'Tilmeldt via',
    loyalty_points: 'Loyalitet',
  },
  empty_list: 'Ingen kunder endnu',
  yes: 'Ja',
  no: 'Nej',
  buttons: {
    import: 'Importér',
    export: 'Eksportér',
  },
  toasts: {
    failed_to_load_data: 'Data kunne ikke indlæses',
  },
  labels: {
    followed_since_date: 'Siden {{date}}',
  },
};

export default {
  ...followers,
  FollowerDetails,
  Import,
};
